import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Event from '../../../event';
import styles from './style.css';

class Video extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.videoRef = React.createRef();
        this.duration = props.content.duration;
        this.currentTime = 0;
        this.advanceEndFlag = false;

        this.state = {
            show: false,
        };
    }

    show() {
        this.setState({ show: true });
    }

    hide() {
        this.setState({ show: false });
        clearInterval(this.timer);
    }

    play() {
        return this.videoRef.current.play();
    }

    pause() {
        return this.videoRef.current.pause();
    }

    setVolume(volume) {
        this.videoRef.current.volume = volume;
    }

    getVolume() {
        return this.videoRef.current.volume;
    }

    setMuted(muted) {
        this.videoRef.current.muted = muted;
    }

    getMuted() {
        return this.videoRef.current.muted;
    }

    getDom() {
        return this;
    }

    handleCanPlay = () => {
        this.trigger('canplay');
    };

    handleTimeupdate = (e) => {
        const currentTime = e.target.currentTime;

        this.currentTime = currentTime;

        if (!this.advanceEndFlag) {
            if (currentTime >= this.duration) {
                this.advanceEndFlag = true;
                this.pause();
                this.trigger('ended');
            } else {
                this.trigger('timeupdate');
            }
        }
    };

    handleEnded = (e) => {
        const currentTime = e.target.currentTime;

        if (currentTime < this.duration) {
            this.timer = setInterval(() => {
                this.currentTime += 0.1;
                this.trigger('timeupdate');

                if (this.currentTime >= this.duration) {
                    clearInterval(this.timer);
                    if (!this.advanceEndFlag) {
                        this.trigger('ended');
                    }
                }
            }, 100);
        }
    };

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    render() {
        const { content } = this.props;
        const { index, url } = content;
        const { show } = this.state;

        return (
            <video
                className={styles.adVideo}
                data-tag={index}
                ref={this.videoRef}
                poster="//p1.ifengimg.com/a/2016/1021/loading0.jpg"
                src={url}
                id="adPlayer"
                preload="auto"
                style={{ display: show ? 'block' : 'none' }}
                onCanPlay={this.handleCanPlay}
                onTimeUpdate={this.handleTimeupdate}
                onEnded={this.handleEnded}
            />
        );
    }
}

Event.mixTo(Video);
export default Video;
